<markant-breadcrumbs
  class="breadcrumbs"
  [autoCollapse]="false"
  maxItems="5"
  itemsAfterCollapse="2"
  itemsBeforeCollapse="2"
>
  <a
    id="back-to-dashboard-button"
    class="back"
    slot="markant-breadcrumbs-back"
    (click)="goBack()"
  >
    <markant-icon icon="m_chevron-left-small"></markant-icon>
    {{ 'common.back' | transloco }}
  </a>
  <markant-breadcrumb
    *ngFor="let breadcrumb of breadcrumbs$ | async; let isLast = last"
    [routerLink]="breadcrumb.url"
    [title]="breadcrumb.url"
    [disabled]="isLast"
    >{{ breadcrumb.label }}
  </markant-breadcrumb>
</markant-breadcrumbs>
